import React, { ErrorInfo } from "react";
import Error from "@/components/entities/error";

interface ErrorState {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

type ErrorBoundaryProps = React.PropsWithChildren<object>;

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error.stack);

    this.setState({
      error,
      errorInfo,
    });
  }

  render(): React.ReactNode {
    const { error } = this.state;

    if (error) {
      return <Error text={error.message} />;
    }

    return this.props.children;
  }
}
